import { getIsWhiteLabel } from './whiteLabel';
import { getLocation } from 'connected-react-router';
import { matchRoutes } from 'react-router-config';
import getRoutes from '@/routes';

export const loadPageData = () => async (dispatch: Function, getState: Function) => {
    const state = getState();

    // Need to know if the app is working as whitelabel
    const isWhiteLabel = getIsWhiteLabel(state);

    // Get application routes
    const routes = getRoutes(isWhiteLabel);

    // Get current location
    const location = getLocation(state);

    // Get all the currently active matching branch routes
    const branch = matchRoutes(routes, location.pathname);

    // Make an array of promises for the page data
    const promises = branch.map(({ match, route }) => {
        if (route.loadData) {
            return route.loadData({ location, match, store: { dispatch, getState } });
        }

        return Promise.resolve();
    });

    return Promise.all(promises);
};
